const handler = {
    set(target, key, value) {
        // Continue the assignment
        target[key] = value;
        BundlesManagerClass.saveBundle(target);

        return true;
    },
};

class ProductForm extends HTMLElement {
    constructor() {
        super();
        const bundle = BundlesManagerClass.getBundle() || {};
        this._bundle = new Proxy(bundle, handler);
        // this.bundleId = this.bundle?.bundleId || this.bundle?.id;
        this.form = this.querySelector('form');
        this.email = this.form.querySelector('[name="properties[Recipient email]"]');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.surveyResponse = null;
        this.variantId = this.dataset.variantId;
        this.isCompletingBundle = false;

        this.cart = document.querySelector('cart-drawer');
        this.submitButtons = this.querySelectorAll('button[name=add]');
        this.submitBundleButton = this.querySelector('button[name="bundle"]');
        this.cancelBundleBtns = this.querySelectorAll('[name="cancel-bundle"]');
        this.completeBundleBtn = this.querySelector('[name="add-to-bundle"]');
        this.startNewBundleBtns = this.querySelectorAll('[name="start-new-bundle"]');

        this.product_type = this.dataset.productType;

        this.productSurveyModal = document.querySelector('[name=quiz-dialog]');
        this.bundleSurveyModal = document.querySelector('[name=bundle-dialog]');
        this.upsellModal = document.querySelector('[name=upsell-dialog]');
        this.successModal = document.querySelector('[name=success-dialog]');
        this.hideErrors = this.dataset.hideErrors === 'true';
        this.updateBundleData();
        this.shouldBundle = true;
        this.upsellWhenIndividual =
            this.product_type === 'orthotic' && Object.keys(bundle)?.length === 0;

        this.updateFormButtons();

        this.productSurveyModal
            ?.closest('typeform-modal')
            ?.addEventListener('submit', this.handleTypeformSubmit.bind(this));

        this.bindButtonsEventListeners();
        const sizeSelectors = [
            this.bundleSurveyModal.querySelector('size-selector'),
            this.upsellModal.querySelector('size-selector'),
        ];

        sizeSelectors.forEach((sizeSelector) => {
            sizeSelector?.addEventListener('submit', async (e) => {
                const { size, gender } = e.detail;
                if (this.partialBundleId) {
                    this.bundle.bundleId = this.partialBundleId;
                }

                await this.initBundle(size, gender);

                if (this.partialBundleId) {
                    await this.convertPartialBundleToBundle();
                } else {
                    this.bundleSurveyModal.close();
                    await this.onSubmitHandler();
                }

                this.updateFormButtons();
                this.updateBundleData();
                window.location = `/collections/footwear?filter.p.m.custom.gender=${gender}&filter.v.option.size=${size}`;
            });
        });

        subscribe(PUB_SUB_EVENTS.bundleCancelled, this.updateBundleData.bind(this));
    }

    get bundle() {
        return this._bundle;
    }

    set bundle(value) {
        if (value && typeof value === 'object') {
            this._bundle = new Proxy(value, this._bundle.constructor.prototype);
        } else {
            this._bundle = value;
        }
        BundlesManagerClass.saveBundle(this._bundle);
    }

    bindButtonsEventListeners() {
        if (this.submitButtons) {
            this.submitButtons.forEach((btn) => {
                btn.addEventListener('click', async (e) => {
                    this.shouldBundle = false;
                   // await this.onSubmitHandler();
                });
            });
        }

        if (this.submitBundleButton) {
            this.submitBundleButton.addEventListener('click', async (e) => {
                if (this.product_type === 'orthotic') {
                    e.preventDefault();
                    this.shouldBundle = true;
                    if (!this.surveyResponse) {
                        this.productSurveyModal.showModal();
                    } else {
                        this.bundleSurveyModal.showModal();
                    }
                    this.complementsBundleType = false;
                } else {
                    await this.initBundle();
                    this.updateBundleData();
                    await this.onSubmitHandler();
                    this.bundleSurveyModal.showModal();
                }
            });
        }

        if (this.cancelBundleBtns) {
            this.cancelBundleBtns.forEach((btn) => {
                btn.addEventListener('click', async (e) => {
                    e.preventDefault();
                    this.bundle.status = BUNDLE_STATUS.NOT_STARTED;
                    this.updateFormButtons();
                    BundlesManagerClass.cancelBundle();
                });
            });
        }

        if (this.completeBundleBtn) {
            this.completeBundleBtn.addEventListener('click', async (e) => {
                e.preventDefault();
                this.isCompletingBundle = true;
                if (this.product_type === 'orthotic') {
                    this.productSurveyModal.showModal();
                } else {
                    this.completeBundle();
                }
            });
        }

        if (this.startNewBundleBtns) {
            this.startNewBundleBtns.forEach((btn) => {
                btn.addEventListener('click', async (e) => {
                    e.preventDefault();
                    // this.bundleStatus = BUNDLE_STATUS.NOT_STARTED;
                    // this.bundleId = Utils.generateBundleId();
                    this.initBundle();
                    await BundlesManagerClass.cancelBundle();
                    this.updateFormButtons();
                    this.productSurveyModal.showModal();
                    this.complementsBundleType = false;
                });
            });
        }
    }

    async completeBundle() {
        await this.onSubmitHandler();
        await BundlesManagerClass.upgradeBundle();

        this.bundle.status = BUNDLE_STATUS.COMPLETE;
        this.updateFormButtons();

        BundlesManagerClass.completeBundle();
        this.successModal.showModal();
        this.isCompletingBundle = false;
    }

    async convertPartialBundleToBundle() {
        const cart = await Shopify.getCart();
        const partialBundleItems = cart.items.filter((item) => {
            return item.properties?._partialBundleId === this.partialBundleId;
        });

        const updatedItems = partialBundleItems.map((item) => {
            return {
                id: item.key,
                properties: {
                    ...item.properties,
                    _partialBundleId: undefined,
                    _bundleId: this.bundle.bundleId,
                },
            };
        });

        for (const item of updatedItems) {
            await Shopify.updateLineItems(item);
        }
    }

    async initBundle(size, gender) {


        const bundle = await BundlesManagerClass.initBundle({
            size,
            gender,
            bundleId: this.bundle?.bundleId || undefined,
            products: [
                {
                    id: this.variantId,
                    handle: this.dataset.handle,
                    title: this.dataset.title,
                    quantity: 1,
                    type: this.product_type,
                    src: this.dataset.imageSrc,
                    altText: this.dataset.imageAltText,
                    bundleVariantId: this.dataset.bundledOrthoticId || undefined,
                },
            ],
        });
        this.bundle = bundle;
    }

    updateFormButtons() {
        const groups = this.querySelectorAll('.bundle-button-groups');
        groups.forEach((group) => group.classList.add('hidden'));

        const bundleStartedIncludedGroup = this.querySelector(
            '[data-name=bundle-started--included]'
        );
        const bundleStartedNotIncludedGroup = this.querySelector(
            '[data-name=bundle-started--not-included]'
        );
        const bundleStartedComplements = this.querySelector(
            '[data-name=bundle-started--complements]'
        );

        const bundleNotStartedGroup = this.querySelector('[data-name=bundle-started--none]');
        const isInBundle = this.variantId == this.bundle?.productsInBundle?.[0]?.id;

        if (this.bundle.status === BUNDLE_STATUS.NOT_STARTED) {
            bundleNotStartedGroup.classList.remove('hidden');
        } else if (this.bundle.status === BUNDLE_STATUS.IN_PROGRESS && this.complementsBundleType) {
            bundleStartedComplements.classList.remove('hidden');
        } else if (
            // when viewing a product of the same type that's not in the same bundle
            this.bundle.status === BUNDLE_STATUS.IN_PROGRESS &&
            !this.complementsBundleType &&
            !isInBundle
        ) {
            bundleStartedNotIncludedGroup.classList.remove('hidden');
        } else if (
            this.bundle.status === BUNDLE_STATUS.IN_PROGRESS &&
            !this.complementsBundleType
        ) {
            bundleStartedIncludedGroup.classList.remove('hidden');
        } else if (this.bundle.status === BUNDLE_STATUS.COMPLETE) {
            bundleNotStartedGroup.classList.remove('hidden');
        } else {
            bundleNotStartedGroup.classList.remove('hidden');
        }
    }

    async onSubmitHandler(evt) {
        evt?.preventDefault();

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const hasFootwearInBundle = this.bundle?.productsInBundle?.some(
            (item) => item?.type === 'footwear'
        );
        var _variantId = this.variantId;
        var _product_form = document.querySelector('product-form');
        if(_product_form){
            _variantId =  _product_form.dataset.variantId;
        }
        const activeItem = {
            id:
                hasFootwearInBundle && this.product_type === 'orthotic'
                    ? this.dataset.bundledOrthoticId
                    : _variantId,
            quantity: 1,
        };

        if (this.bundle?.bundleId && this.shouldBundle) {
            activeItem.properties = {
                _bundleId: this.bundle.bundleId,
            };
        } else {

            // in case the product is later added to a bundle
            // a partial bundle id is required to separate this item
            // from other items in the cart that are the same, otherwise
            // they will get grouped together
            this.partialBundleId = Utils.generateBundleId();
            activeItem.properties = {
                _partialBundleId: this.partialBundleId,
                _minicart_image: this.dataset.imageMinicart
            };
        }

        if (this.surveyResponse) {
            activeItem.properties = {
                ...(activeItem.properties || {}),
                ...this.surveyResponse,
            };
        }

        const items = [activeItem];

        // data-foamkit-id is only rendered when the "Show Foam Kit" theme setting is enabled
        const foamKitId = this.dataset.foamkitId;
        if (this.product_type === 'orthotic' && foamKitId && foamKitId.trim() !== '') {
            items.push({
                id: this.dataset.foamkitId,
                quantiy: 1,
            });
        }
        if (this.product_type === 'Gift Card') {
            if(this.email) {
                const val = this.email.value;
                const emailRegex = /^([a-z0-9,!\#\$%&'\*\+\/=\?\^_`\{\|\}~-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z0-9,!\#\$%&'\*\+\/=\?\^_`\{\|\}~-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*@([a-z0-9-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z0-9-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*\.(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]){2,})$/i.test(val);
                if(!emailRegex){
                    var _html = '<span><svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g id="Group-2" fill="#E30000" fillRule="nonzero"><g id="!" transform="translate(5.592000, 3.288000)"><path d="M0,4.824 L0,5.712 L0.888,5.712 L0.888,4.824 L0,4.824 Z M0.824,1.76 L0.824,0 L0.064,0 L0.064,1.76 L0.264,4.248 L0.624,4.248 L0.824,1.76 Z"></path></g><path d="M6,0 C9.3137085,0 12,2.6862915 12,6 C12,9.3137085 9.3137085,12 6,12 C2.6862915,12 0,9.3137085 0,6 C0,2.6862915 2.6862915,0 6,0 Z M6,1 C3.23857625,1 1,3.23857625 1,6 C1,8.76142375 3.23857625,11 6,11 C8.76142375,11 11,8.76142375 11,6 C11,3.23857625 8.76142375,1 6,1 Z" id="Oval"></path></g></g></svg></span>';
                    _html += 'Please enter a valid recipient email address';
                    document.getElementById("email-error-message").innerHTML = _html;
                    return;
                }
            }
        }
        await Shopify.addToCart(items, { open: false });

        if (!this.cart) {
            // navigate to cart page if cart drawer is not defined
            window.location = window.routes.cart_url;
            return;
        }
        this.cart.open();
    }

    async handleTypeformSubmit(e) {
        const { formId, responseId } = e.detail;
        async function getFormData() {
            const hasFilledFormRequest = await fetch(
                'https://orthotics-direct-functions.netlify.app/.netlify/functions/get-form-responses',
                {
                    method: 'POST',
                    body: JSON.stringify({ responseId }),
                }
            );

            if (window.ENVIRONMENT === 'development') {
                return {
                    Age: '50',
                };
            }
            if (hasFilledFormRequest.status === 404 && window.ENVIRONMENT !== 'development') {
                throw new Error('No form data found');
            } else {
                const { orderData } = await hasFilledFormRequest.json();
                return orderData;
            }
        }

        const submitForm = async () => {
            const orderData = await getFormData();
            let updatedData = Object.keys(orderData).reduce((acc, key) => {
                if (!orderData[key]?.startsWith('http')) {
                    acc[key] = orderData[key];
                }
                return acc;
            }, {});
            // prepending every key with _ to make it a private attribute—the customer doesn't need to see this data
            updatedData = Object.keys(updatedData).reduce((acc, key) => {
                acc[`_${key}`] = updatedData[key];
                return acc;
            }, {});

            this.surveyResponse = updatedData;
            if(window.FLAGS.bundles){
              if (this.shouldBundle) {
                  this.productSurveyModal.close();
                  if (this.isCompletingBundle) {
                      this.completeBundle();
                  } else {
                      this.bundleSurveyModal.showModal();
                  }
              } else {
                  await this.onSubmitHandler();
                  this.productSurveyModal.close();
                  if (this.upsellWhenIndividual) {
                      this.upsellModal.showModal();
                  } else {
                      this.cart.open();
                  }
              }
            } else {
              await this.onSubmitHandler();
              this.productSurveyModal.close();
              this.cart.open();
            }
        };

        setTimeout(async () => {
            let submitted = false;
            for (let i = 0; i < 10; i++) {
                try {
                    await submitForm();
                    submitted = true;
                    break;
                } catch (e) {
                    console.log(e);
                    await Utils.wait(1000);
                }
            }

            if (!submitted) {
                alert('There has been an error submitting your form.');
                productSurveyModal.close();
            }
        }, 1000);
    }

    updateBundleData() {
        const bundle = BundlesManagerClass.getBundle();
        if (bundle) {
            this.bundle = bundle;
            // this.currentBundle = bundle;
            // this.bundleId = this.currentBundle.bundleId;
            // this.bundleStatus = this.currentBundle.status;
            this.complementsBundleType =
                this.bundle?.productsInBundle?.[0]?.type !== this.product_type || false;
        }
    }
    handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
        }
    }
}

if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductForm);
}
